<template>
    <div>
        <span class="p-country-name" style="display:none;">Japan</span>

        <div class="flex align-items-center mb20"><span class="mr10">〒</span>
            <input placeholder="郵便番号"
                type="text"
                style="width: 105px; margin-right: 20px"
                class=" form-control p-postal-code"
                size="8"
                v-model="zipCode"
                maxlength="8">
            <button type="button" @click="searchAddress"
                    class="btn btn-accent">郵便番号で住所検索</button>
            <div v-if="zipMessage" class="ml20 text-danger">住所が取得できませんでした</div>
        </div>

        <input placeholder="住所/マンション名等"
            required="required"
            ref="delivery_address"
            autofocus="autofocus"
            name="delivery_address"
            type="text"
            :value="address || defaultAddress"
            class="form-control">
    </div>
</template>

<script>
  import linq from 'linq'
  import { mapActions, mapGetters } from 'vuex'
  import { action, getter } from '../../store/types'
  import User from '../../models/User'
  import UserDeliveryAddress from '../../models/UserDeliveryAddress'

  export default {
      name: 'checkout-address-form',

      data () {
          return {
              address: '',
              user: new User(),
              zipCode: '',
              zipMessage: ''
          }
      },

      props: {
        _user: {
          type: String
        },
          old: {
              type: String,
              default: ''
          }
      },

      computed: {
          ...mapGetters({
              get_user: [getter.USER_ADDRESSES],
          }),

          defaultAddress () {
              this.address = ''
              if(this.old) {
                 return this.old
              }
              return linq.from(this.get_user.deliveryAddresses)
                  .firstOrDefault(x => x.default === 1 ,new UserDeliveryAddress).deliveryAddress
          }
      },

      async created () {
        this.user = new User(JSON.parse(this._user))
        await this[action.UPDATE_USER_ADDRESSES] (this.user)
      },

      methods: {
          ...mapActions([
              action.UPDATE_USER_ADDRESSES,
          ]),

          searchAddress() {
              this.zipMessage = false
              if(!this.zipCode) return this.zipMessage = true
              axios.get('api/zipcode/' + this.zipCode).then((res) => {
                  if(res.data.err) return this.zipMessage = true

                  this.$refs.delivery_address.value = this.zipCode + ' '
                      + res.data[0]['allAddress']
              })
          },

          clearAddress() {
              this.address = ''
          },
      }
  }

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/checkout/CheckoutAddressForm.vue